import { render } from "./WidthEditor.vue?vue&type=template&id=a8f8c9ee&scoped=true&ts=true"
import script from "./WidthEditor.vue?vue&type=script&lang=ts"
export * from "./WidthEditor.vue?vue&type=script&lang=ts"

import "./WidthEditor.vue?vue&type=style&index=0&id=a8f8c9ee&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/test-saas-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8f8c9ee"]])

export default __exports__